import {
  STATUS_FILTER_OPTIONS,
  URGENCY_ORDER,
} from 'components/student-insights/constants'

export const statusFilterFromSearch = search => {
  const status = new URLSearchParams(search).get('status')
  return STATUS_FILTER_OPTIONS.some(option => option.value === status)
    ? status
    : 'all'
}

// True when every GraphQL error came from a student's insights field, so the
// rest of the students list is still usable.
export const isInsightsOnlyError = error =>
  Boolean(error?.graphQLErrors?.length) &&
  !error.networkError &&
  error.graphQLErrors.every(({ path }) => path?.includes('insights'))

export const matchesStatusFilter = ({ insights }, filter) => {
  if (filter === 'all') return true
  if (filter === 'attention') return Boolean(insights?.needsAttention)
  return insights?.status === filter
}

// Needs follow-up first, then most urgent status, then longest in that status.
// Students without insights stay last in either direction.
export const sortByRetention = (a, b, dir) => {
  const first = a.props.student.insights
  const second = b.props.student.insights
  if (!first || !second) return Boolean(second) - Boolean(first)

  const queueRank = insights => (insights.needsAttention ? 0 : 1)
  const result =
    queueRank(first) - queueRank(second) ||
    URGENCY_ORDER.indexOf(first.status) -
      URGENCY_ORDER.indexOf(second.status) ||
    (first.statusChangedAt || '').localeCompare(second.statusChangedAt || '')
  return dir === 'desc' ? -result : result
}
